import { render, staticRenderFns } from "./updateAdminForm.vue?vue&type=template&id=64706b2f&scoped=true"
import script from "./updateAdminForm.vue?vue&type=script&lang=js"
export * from "./updateAdminForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64706b2f",
  null
  
)

export default component.exports